<div class="donut">
  <!-- See bar-chart.component.html: group, not img — this svg holds controls. -->
  <svg class="chart-svg" viewBox="0 0 100 100" role="group"
       [attr.aria-label]="ariaLabel">

    <g transform="rotate(-90 50 50)">
      <circle class="track" [attr.cx]="50" [attr.cy]="50" [attr.r]="r"
              fill="none" [attr.stroke-width]="thickness"/>

      <!-- aria-pressed only when the parent actually has a selection model.
           A dashboard that drills on click has no pressed state, and a button
           reporting aria-pressed="false" forever claims to be a toggle it is
           not. Same reasoning as the line chart's conditional role. -->
      <circle *ngFor="let arc of arcs; trackBy: trackArc"
              class="chart-hit arc"
              [class.dimmed]="selectedId && selectedId !== arc.id"
              [attr.cx]="50" [attr.cy]="50" [attr.r]="r"
              fill="none"
              [attr.stroke]="arc.color"
              [attr.stroke-width]="thickness"
              [attr.stroke-dasharray]="arc.dash + ' ' + c"
              [attr.stroke-dashoffset]="arc.offset"
              tabindex="0"
              role="button"
              [attr.aria-pressed]="selectedId === null ? null : selectedId === arc.id"
              [attr.aria-label]="arc.label + ' ' + arc.pct.toFixed(0) + '%'"
              (click)="onSelect(arc)"
              (keydown.enter)="onSelect(arc, $event)"
              (keydown.space)="onSelect(arc, $event)"/>
    </g>
  </svg>

  <div class="center" *ngIf="centerValue || centerLabel">
    <div class="value" *ngIf="centerValue">{{ centerValue }}</div>
    <div class="label" *ngIf="centerLabel">{{ centerLabel }}</div>
  </div>

  <table class="chart-data">
    <caption>{{ ariaLabel }}</caption>
    <tbody>
      <tr *ngFor="let arc of arcs; trackBy: trackArc">
        <th scope="row">{{ arc.label }}</th>
        <td>{{ arc.pct.toFixed(1) }}%</td>
      </tr>
    </tbody>
  </table>
</div>
